<template>
  <div class="cutter-progress">
    <div class="cutter-progress-icon">
      <iconfont
        class="cutter-loading-icon"
        style="font-size:41px;"
        name="#icon11-41jianjizhong"
        color="#ffffff"
      ></iconfont>
      <span>视频正在处理中，请耐心等待...</span>
    </div>
    <div class="progress-persent-box">
      <div class="cutter-progress-persent">
        <div :style="{ width: percent + '%' }"></div>
      </div>
      <div
        class="cutter-cancel-btn"
        @click="cancel"
      >
        <div>
          <iconfont
            name="#icon20-12guanbianniujiaohu"
            color="#ffffff"
            font-size="8px"
          ></iconfont>
        </div>
        <span>取消</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: null,
      timeout: null
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      percent: 0,
      queue: 0,
      cut: 0,
      num: 1
    };
  },
  watch: {
    info() {
      if (this.info.taskId) {
        this.checkTaskStatus(this.info.taskId);
      }
    }
  },
  mounted() {
    if (this.info.taskId) {
      this.checkTaskStatus(this.info.taskId);
    }
  },
  methods: {
    cancel() {
      this.timeout && clearTimeout(this.timeout);
      this.$http({
        url: `/onlineTask/${this.info.taskId}`,
        method: 'delete',
        headers: {
          'Content-Type': '	application/x-www-form-urlencoded'
        }
      });
      this.$emit('cancel');
      this.$bus.emit(`taskCancel.${this.type}`, this.info);
    },
    checkTaskStatus(taskId) {
      this.checkStatus(taskId).then((res) => {
        res = parseFloat(res);
        if (0 < res && res < 1) {
          this.queue = 100;
          this.cut = res * 100;
          this.num++;
          if (!(this.num % 5)) this.hasfile(this.info.newkey);
        } else if (res == 1) {
          this.cut = 100;
          this.queue = 100;
          this.timeout && clearTimeout(this.timeout);
          this.$bus.emit(`taskSuccess.${this.type}`, this.info);
          this.$emit('cancel');
        } else if (res == -1) {
          this.cut = 0;
          this.queue < 100 && (this.queue += 5);
        } else if (res == -2) {
          this.cut = 0;
          this.queue = 0;
          this.timeout && clearTimeout(this.timeout);
          this.$emit('cancel');
          this.$message({
            message: '任务失败',
            type: 'error',
            center: true
          });
          return;
        }
        this.percent = Math.floor(this.cut * 0.82 + this.queue * 0.18);
      });

      this.timeout = setTimeout(() => {
        this.checkTaskStatus(taskId);
      }, 2000);
    },
    async checkStatus(taskId) {
      let result = await this.$http.get(`/onlineTask/getProgress?taskId=${taskId}`);
      if (result.status === 200 && result.data.code === 200) {
        return result.data.data;
      }

      return false;
    },
    hasfile(url) {
      try {
        let xml = new XMLHttpRequest();
        xml.open('get', this.$.handleAssetsUrl(url), false);
        xml.send();
        if (xml.status < 400) {
          console.log('sueccess');
          clearTimeout(this.timeout);
          this.$bus.emit(`taskSuccess.${this.type}`, this.info);
          this.$emit('cancel');
        }
      } catch (e) {
        return false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.cutter-progress {
  width: 500px;
  height: 164px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.cutter-progress-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;

  span {
    margin-top: 15px;
    color: #ffffff;
  }
}
.cutter-loading-icon {
  animation: turn 2s linear infinite;
}
.progress-persent-box {
  width: 490px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 28px;
}
.cutter-progress-persent {
  width: 420px;
  height: 8px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 4px;

  > div {
    width: 200px;
    height: 8px;
    background-color: #ffffff;
    border-radius: 4px;
  }
}
.cutter-cancel-btn {
  width: 53px;
  height: 24px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  > div {
    width: 24px;
    height: 24px;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    line-height: 24px;
  }

  &:hover > div {
    background-color: rgba(0, 0, 0, 0.2);
  }

  span {
    color: #ffffff;
    opacity: 0.5;
  }
}
@keyframes turn {
  0% {
    -webkit-transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>
